<script>
import AppLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters} from "vuex";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "LossWorkingCase",
  mixins:[permissionMixin],
  components: {AppLoading},
  data() {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - 5 + i);
    return {
      loading : true,
      years,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          events:{
            xAxisLabelClick: function(event, chartContext, config){
              if (this.isAllowed('menu.reports.accident-incident') === false) {
                return;
              }
              const medical_severity_name = this.loss_working_case[config.labelIndex].name;
              const data = this.loss_working_case[config.labelIndex].data;
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', true);
              $('#safetyAndHealthModal').modal('show');

              const data_table = {
                text_header : `Loss working case (${medical_severity_name})`,
                safety_and_health_module : 'loss_working_case',
                data : data
              };

              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_CHART_DATA', data_table)
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', false);
            }.bind(this)
          }
        },
        title: {
          text: 'LOSS WORKING CASE',
          align: 'center',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          colors: ['#000']
        },
        tooltip: {
          followCursor : true,
          shared: true,
          intersect: false
        },
        fill: {
          colors: ['#bfbfbf', '#a6a6a6', '#ffd966', '#f7caac', '#f4b083', '#ff0000']
        },
        grid: {
          borderColor: '#e9e9e9',
          position: 'front',
          xaxis: {
            lines: {
              show: true,
            }
          }
        },
        xaxis: {
          categories: [],
        },
      },
    }
  },
  methods : {
    ...mapActions(['getAccidentSafetyAndHealthChartsData'])
  },
  mounted() {
    const yearsColors=['#bfbfbf','#a6a6a6','#ffd966','#f7caac','#f4b083','#ff0000']
    this.chartOptions.xaxis.categories = this.loss_working_case.map(item => {
      return item.name.toUpperCase()
    })

    this.years.forEach((year, index) => {
      let yearData = [];
      this.loss_working_case.forEach(item => {
        item.data.forEach(lossData => {
          if (lossData.year === year) {
            yearData.push(lossData.values.length);
          }
        })
      });
      this.series.push({
        color : yearsColors[index],
        name : year,
        data : yearData
      })
    });
  },
  computed : {
    ...mapGetters([
      'airSafetyAndHealthGraphDataLoading',
      'loss_working_case',
      'cmsRequestedOnBoardCrew',
    ]),
  }
}
</script>

<template>
  <div>
    <div v-if="airSafetyAndHealthGraphDataLoading">
      <app-loading></app-loading>
    </div>
    <div v-else>
      <apexchart
        type="bar"
        :height="chartOptions.xaxis.categories.length * 50"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>

  </div>
</template>

<style scoped>

</style>
